/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type SuggestionBodyWeeklyAutopilotSummary_suggestionPayload = {
    readonly historicalDefragBenefitScore?: {
        readonly totalFocusTimeSavings: number;
        readonly conflictsResolved: number;
        readonly affectedCalendars: ReadonlyArray<string>;
        readonly meetingsMoved: number;
    } | undefined;
    readonly dateRangeMin?: string | undefined;
    readonly dateRangeMax?: string | undefined;
    readonly " $refType": "SuggestionBodyWeeklyAutopilotSummary_suggestionPayload";
};
export type SuggestionBodyWeeklyAutopilotSummary_suggestionPayload$data = SuggestionBodyWeeklyAutopilotSummary_suggestionPayload;
export type SuggestionBodyWeeklyAutopilotSummary_suggestionPayload$key = {
    readonly " $data"?: SuggestionBodyWeeklyAutopilotSummary_suggestionPayload$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"SuggestionBodyWeeklyAutopilotSummary_suggestionPayload">;
};



const node: ReaderFragment = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "SuggestionBodyWeeklyAutopilotSummary_suggestionPayload",
    "selections": [
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "HistoricalDefragBenefitScore",
                    "kind": "LinkedField",
                    "name": "historicalDefragBenefitScore",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "totalFocusTimeSavings",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "conflictsResolved",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "affectedCalendars",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "meetingsMoved",
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "dateRangeMin",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "dateRangeMax",
                    "storageKey": null
                }
            ],
            "type": "SuggestionResultWeeklyAutopilotSummaryPayload",
            "abstractKey": null
        }
    ],
    "type": "SuggestionResultPayload",
    "abstractKey": "__isSuggestionResultPayload"
} as any;
(node as any).hash = '3f9e39a35fcf4ebf3a29b2d8e0f9c246';
export default node;
